import { connect } from 'react-redux';
import { setError } from '../../store/actions/site.actions';
import { getNotification } from '../../store/selectors/site.selectors';
import ReactNotificationTrigger from './ReactNotificationTrigger';

const mapStateToProps = (state: any) => {
    const data = getNotification(state);

    return {
        isError: data.isError,
        errorCode: data.errorCode,
        message: data.message,
        notificationType: data.notificationType,
    };
};

const mapDispatchToProps = { setError };

export default connect(mapStateToProps, mapDispatchToProps)(ReactNotificationTrigger);
